import { specialFont } from '../../Infrastructure/Theme/fontFamily'

const careersSx = {
    root: {
        width: '100%',
        maxWidth: 'lg',
        mx: 'auto',
        minHeight: '100vh',
        py: { md: 4 },
        px: { xs: 0, sm: 0, md: 4 },
    },
    heroContainer: {
        height: { xs: '90vh', md: '100vh' },
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        gap: 4,
    },
    heroContent: {
        display: 'flex',
        flexDirection: { xs: 'column-reverse', md: 'row' },
        mt: { xs: 0, md: 5 },
        alignItems: 'center',
        justifyContent: 'center',
        gap: 4,
    },
    heroTextBox: {
        flex: 1,
        textAlign: { xs: 'center', md: 'left' },
    },
    heroTitle: {
        fontSize: { xs: 28, md: 44 },
        fontWeight: 'bold',
        fontFamily: specialFont,
    },
    heroSubtitle: {
        mx: { xs: 2, md: 0 },
    },
    heroImageBox: {
        flex: 1,
        display: 'flex',
        justifyContent: 'center',
        width: { xs: '100%' },
    },
    seeOpportunitiesBox: {
        textAlign: 'center',
        mb: { xs: 12, md: 18 },
    },
    seeOpportunitiesText: {
        cursor: 'pointer',
        textDecoration: 'underline',
        display: 'inline',
    },
    listingsContainer: {
        mt: 4,
        minHeight: '100vh',
        px: { xs: 2, sm: 3, md: 4 },
    },
    listingsTitle: {
        fontWeight: 600,
        textUnderlineOffset: 5,
        fontSize: { xs: 22, sm: 28, md: 44 },
        fontFamily: specialFont,
    },
    divider: {
        my: 3,
        width: '100%',
        borderBottom: '2px solid grey',
    },
    categoryTitle: {
        fontWeight: 600,
        fontSize: '18px',
        fontFamily: specialFont,
        textTransform: 'capitalize',
    },
    jobItem: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        px: 0,
        textUnderlineOffset: 5,
    },
    jobRow: {
        display: 'flex',
        justifyContent: 'space-between',
        width: '100%',
    },
    jobLink: {
        textDecoration: 'none',
        textTransform: 'capitalize',
        textAlign: 'start',
    },
    jobLocation: {
        textTransform: 'capitalize',
        pl: { xs: 2, md: 0 },
    },
    jobDivider: {
        my: 3,
        width: '100%',
        borderBottom: '3px solid grey',
    },
    emptyState: {
        my: 4,
        textAlign: 'center',
        color: 'gray',
    },
}

const jobLisitingSx = {
    jobListingContainer: {
        py: 4,
        minHeight: '100vh',
    },
    backButton: {
        flexShrink: 0,
        mb: 2,
        cursor: 'pointer',
        fontSize: 24,
    },
    jobTitle: {
        fontSize: { xs: 22, sm: 28, md: 35 },
        textTransform: 'capitalize',
        fontWeight: 'bold',
    },
    jobSubheading: {
        fontWeight: 500,
    },
    jobLocationText: {
        textTransform: 'capitalize',
        textAlign: 'end',
    },
    applyBox: {
        mt: 2,
        display: 'flex',
        justifyContent: 'space-between',
    },
    descriptionTitle: {
        fontWeight: 'bold',
    },
    descriptionBody: {
        wordBreak: 'break-word',
        fontWeight: 400,
        mt: 2,
    },
    applyButtonBox: {
        mt: 4,
    },
}

export { careersSx, jobLisitingSx }
